import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Sparkles, CreditCard, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const UpgradeOffer = ({ quote, headers, start, heading, label = 'Upgrade offer', note }) => {
  const [busy, setBusy] = useState('');
  const pay = async (method) => {
    setBusy(method);
    try {
      const body = { guide_id: quote.guide_id, payment_method: method, origin_url: window.location.origin };
      const r = start ? await start(body) : await axios.post(`${API}/orders/mine/upgrade`, body, headers);
      window.location.href = r.data.checkout_url;
    } catch (err) { toast.error(err?.response?.data?.detail || 'Could not start the upgrade'); setBusy(''); }
  };
  return (
    <div className="rounded-2xl bg-[#2D1037] text-[#FAF7F2] p-6 border border-[#C5A059]/40" data-testid={`upgrade-offer-${quote.guide_id}`}>
      <p className="text-xs uppercase tracking-[0.2em] text-[#C5A059] mb-2 inline-flex items-center gap-2"><Sparkles size={14} /> {label}</p>
      <p className="font-display text-2xl mb-1">{heading || `Upgrade to ${quote.bundle_title.replace(/^The /, 'the ')}`}</p>
      <p className="text-sm text-[#FAF7F2]/70 mb-4">
        {quote.guide_title}. You've already paid A${quote.credit} ({quote.owned.join(', ')}), so you only pay the difference.
      </p>
      {note && <p className="text-sm text-[#E5C178] mb-4" data-testid="upgrade-offer-note">{note}</p>}
      <div className="flex flex-wrap items-center gap-4">
        <span className="font-display text-3xl text-[#E5C178]" data-testid={`upgrade-due-${quote.guide_id}`}>A${quote.due}</span>
        <span className="text-sm text-[#FAF7F2]/50 line-through">A${quote.regular_due || quote.bundle_price}</span>
        <button onClick={() => pay('stripe')} disabled={!!busy} data-testid={`upgrade-pay-stripe-${quote.guide_id}`} className="btn-gold text-sm inline-flex items-center gap-2">
          {busy === 'stripe' ? <Loader2 size={14} className="animate-spin" /> : <CreditCard size={14} />} Upgrade by card
        </button>
        <button onClick={() => pay('paypal')} disabled={!!busy} data-testid={`upgrade-pay-paypal-${quote.guide_id}`} className="text-sm text-[#E5C178] hover:text-[#C5A059] inline-flex items-center gap-2">
          {busy === 'paypal' && <Loader2 size={14} className="animate-spin" />} or PayPal
        </button>
      </div>
    </div>
  );
};
